import React from 'react';
import './TrustReport.css';

function TrustReport() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Trust Report</h1>
        <p className="lead">Comprehensive trust analytics and reporting</p>
      </div>
      
      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Trust Metrics</h3>
                <p>Key trust indicators and metrics</p>
                <i className="bi bi-graph-up feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Report Generation</h3>
                <p>Generate custom trust reports</p>
                <i className="bi bi-file-earmark-text feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Compliance Status</h3>
                <p>Track trust compliance levels</p>
                <i className="bi bi-shield-check feature-icon"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-8">
            <div className="card">
              <div className="card-body">
                <h4>Recent Reports</h4>
                <div className="reports-list">
                  <div className="report-item">
                    <div className="report-icon">
                      <i className="bi bi-file-pdf text-danger"></i>
                    </div>
                    <div className="report-info">
                      <h5>Q3 Trust Analysis Report</h5>
                      <p>Generated on August 28, 2025</p>
                    </div>
                    <div className="report-actions">
                      <button className="btn btn-sm btn-outline-primary">
                        <i className="bi bi-download"></i>
                      </button>
                    </div>
                  </div>
                  <div className="report-item">
                    <div className="report-icon">
                      <i className="bi bi-file-excel text-success"></i>
                    </div>
                    <div className="report-info">
                      <h5>Monthly Trust Metrics</h5>
                      <p>Generated on August 25, 2025</p>
                    </div>
                    <div className="report-actions">
                      <button className="btn btn-sm btn-outline-primary">
                        <i className="bi bi-download"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h4>Trust Score</h4>
                <div className="trust-score">
                  <div className="score-circle">
                    <span className="score">92</span>
                    <span className="score-label">Trust Score</span>
                  </div>
                  <div className="score-details">
                    <div className="detail-item">
                      <span>Reliability</span>
                      <span>95%</span>
                    </div>
                    <div className="detail-item">
                      <span>Security</span>
                      <span>90%</span>
                    </div>
                    <div className="detail-item">
                      <span>Compliance</span>
                      <span>88%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrustReport;
